export default function ({ query, app }) {
	if (query.lang && app.i18n.locales.some(locale => locale.code === query.lang)) {
		app.i18n.setLocale(query.lang)
	} else {
		app.i18n.setLocale('en')
	}
}
